// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";


const FacilityActivationService = {};

FacilityActivationService.getFacilityActivationService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    customername: data.customername || "",
    facilityid: data.facilityid || "",
    branchId: data.branchId || "",
  });

  return lossClient({
    url: `/FacilityActivation/search?${params.toString()}`,
    method: "get",
  });
};

FacilityActivationService.getPrintService = function (data) {
  const params = new URLSearchParams({
    facilityid: data.facilityid || "",
  });

  return lossClient({
    url: `/JsReport/facility?${params.toString()}`,
    method: "get",
  });
};

FacilityActivationService.addFacilityActivationService = function (data) {
  return lossClient({
    url: `/FacilityActivation/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

export default FacilityActivationService;
